import AUStates from './vi-VN/AU-states.json.js';
import CAStates from './vi-VN/CA-states.json.js';
import CNStates from './vi-VN/CN-states.json.js';
import CompanySize from './vi-VN/company-size.json.js';
import CompanyType from './vi-VN/company-type.json.js';
import countries from './vi-VN/countries.json.js';
import DEStates from './vi-VN/DE-states.json.js';
import HKStates from './vi-VN/HK-states.json.js';
import INStates from './vi-VN/IN-states.json.js';
import industry from './vi-VN/industry.json.js';
import interests from './vi-VN/interests.json.js';
import jobRole from './vi-VN/job-role.json.js';
import levelOfAWSUsage from './vi-VN/level-of-aws-usage.json.js';
import projectTimeline from './vi-VN/project-timeline.json.js';
import PTStates from './vi-VN/PT-states.json.js';
import USStates from './vi-VN/US-states.json.js';
import useCase from './vi-VN/use-case.json.js';
import languagePreference from './vi-VN/language-preference.json.js';
import Navatar from '../vi-VN/translation.json.js';

const dropdownsData = {
    ...AUStates,
    ...CAStates,
    ...CNStates,
    ...CompanySize,
    ...CompanyType,
    ...countries,
    ...DEStates,
    ...HKStates,
    ...INStates,
    ...industry,
    ...interests,
    ...jobRole,
    ...levelOfAWSUsage,
    ...projectTimeline,
    ...PTStates,
    ...USStates,
    ...useCase,
    ...Navatar.translation,
    ...languagePreference,
};

export { dropdownsData as default };
